import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const AllSessionsPageStyled = styled(Box)(() => ({
  ".content-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },

  ".session-details-link": {
    cursor: "pointer",
  },
}));
